import logo from '../../assets/images/logo.png';
import { useFullScreenLoaderRegistration } from './fullScreenLoaderState';

interface FullScreenLoaderProps {
  isLoading: boolean;
}

export function FullScreenLoader({ isLoading }: FullScreenLoaderProps) {
  useFullScreenLoaderRegistration(isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-[9999] animate-in fade-in duration-200">
      <div className="flex flex-col items-center justify-center">
        <img src={logo} alt="Loading" className="h-[75px] w-auto object-contain animate-pulse" />
      </div>
    </div>
  );
}
